import PropTypes from "prop-types";
import React, { useEffect } from "react";
import FeedsShowMore from "web/react/components/feeds-show-more/feeds-show-more";
import store from "web/redux/store";
import { setAll } from "web/redux/ducks/feed-show-more";

function FeedsShowMoreContainer({
    visibleProductCount,
    totalProductCount,
    buttonNextUrl,
    buttonText,
}) {
    useEffect(() => {
        store.dispatch(
            setAll({
                visible_product_count: visibleProductCount,
                total_product_count: totalProductCount,
                show_more_next_url: buttonNextUrl,
                show_more_text: buttonText,
            })
        );
    });
    return (
        <React.Fragment>
            <FeedsShowMore
                visibleProductCount={visibleProductCount}
                totalProductCount={totalProductCount}
                buttonNextUrl={buttonNextUrl}
                buttonText={buttonText}
            />
        </React.Fragment>
    );
}

export default FeedsShowMoreContainer;

FeedsShowMoreContainer.propTypes = {
    visibleProductCount: PropTypes.number,
    totalProductCount: PropTypes.number,
    buttonNextUrl: PropTypes.string,
    buttonText: PropTypes.string,
};
